import { useQuery } from 'react-query'
import { useSelector } from 'react-redux'
import { getLoggedInUserIdentity } from 'shared/administration/api/identity'

import { currentUserSelector } from '../../redux/selectors/users'
import { ApplicationState } from '../../redux/store/models'

export function useManagementIdentity() {
  const user = useSelector(currentUserSelector)
  const authenticated = useSelector((state: ApplicationState) => state.auth.isAuthenticated)
  return useQuery(['management-identity', user.id], getLoggedInUserIdentity, {
    enabled: authenticated && !!user.id && !!(user.is_staff || user.can_operate_fleet),
    retry: false,
    staleTime: 0,
  })
}
